import { Country } from "../app/model/country.enum";
import { LoggingLevel } from "../app/model/logging-level.enum";

/**
 * @description
 *  (Angular) The file contents for the current environment will overwrite
 *  these during build. The build system defaults to the dev environment
 *  which uses `environment.ts`, but if you do `ng build --env=prod` then
 *  `environment.prod.ts` will be used instead. The list of which env maps
 *  to which file can be found in `angular.json`.
 */

export const environment = {
    //API_URL: "https://gigotprod.azurewebsites.net/",
    //API_URL: "https://localhost:44364/", //IIS
    API_URL: "https://gigotqa.azurewebsites.net/",
    REWARDS_API_URL: "https://gigotrewards.azurewebsites.net/",
    CACHE_STYLE_CONFIG: true,
    GOOGLE_MAPS_API_KEY: "AIzaSyDdVr5mCjXV7mHO7I2OudmYIfjKgb3rA6M",
    authTokenKey: "ce9d77b308c149d5992a80073637e4d5",
    loggingLevel: LoggingLevel.DEBUG,
    production: false,
    profileCompleted: false,
    country: Country.ARGENTINA
};


